import { createApp, h, onMounted, ref } from 'vue'
import DOMPurify from 'dompurify'

export default async function ({
  title = '',
  html = '',
  text = '',
  buttons = [{ text: 'OK', style: 'btn-action', action: { isConfirmed: true } }],
  icon = 'fak fa-frt-warning text-amber-500',
  isClosable = false
}) {
  return new Promise((resolve) => {
    let container = document.getElementById('custom-alertbox-container')
    if (!container) {
      container = document.createElement('div')
      container.id = 'custom-alertbox-container'
      document.body.appendChild(container)
    }

    const app = createApp({
      setup() {
        const isVisible = ref(false)
        onMounted(() => {
          setTimeout(() => {
            isVisible.value = true
          }, 0)
        })

        const action = (query) => {
          resolve(query)
          app.unmount()
          container.remove()
        }

        return () =>
          h(
            'div',
            {
              class: [
                'fixed top-0 left-0 w-full h-full bg-black/75 backdrop-blur-xs z-50 flex items-center justify-center transition-opacity duration-250 p-5',
                isVisible.value ? 'opacity-100' : 'opacity-0'
              ]
            },
            [
              h(
                'div',
                {
                  class: [
                    'flex flex-col gap-5 w-full xs:w-auto xs:min-w-md bg-white rounded p-5 xs:p-10 text-center items-center justify-center transform transition-transform duration-250 max-w-200',
                    isVisible.value ? 'scale-100' : 'scale-90'
                  ]
                },
                [
                  isClosable
                    ? h(
                        'button',
                        {
                          class: 'absolute top-5 right-5 text-gray-500 hover:text-gray-700',
                          onClick: () => action({ isCancelled: true })
                        },
                        [h('i', { class: 'fa-2xl fak fa-frt-cancel cursor-pointer' })]
                      )
                    : null,
                  icon ? h('i', { class: `text-4xl ${icon}` }) : null,
                  h('h3', { class: 'text-xl font-medium' }, title),
                  html ? h('div', { innerHTML: DOMPurify.sanitize(html) }) : null,
                  text ? h('div', { class: 'mb-5' }, text) : null,
                  buttons.length > 0
                    ? h(
                        'div',
                        { class: 'mt-5 flex items-center gap-3' },
                        buttons.map((button, index) =>
                          button
                            ? h(
                                'button',
                                {
                                  key: index,
                                  id: `alertbox-button-${index}`,
                                  class: ['btn btn-lg', button.style],
                                  onClick: () => action(button.action)
                                },
                                button.text
                              )
                            : null
                        )
                      )
                    : null
                ].filter(Boolean)
              )
            ]
          )
      }
    })

    app.mount(container)
  })
}
